<template>
  <v-app id="inspire">
    <nav>
      <v-navigation-drawer
        fixed
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
        v-model="drawer"
        bottom
        class="grey lighten-3"
      >
        <v-list nav dense>
          <v-list-item-group v-model="group" active-class="blue--text">
            <v-list-item
              v-for="item in items"
              :key="item.title"
              :to="item.url"
              link
              :disabled="isMenuDisabled"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar
        color="blue darken-3"
        dark
        app
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        fixed
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

        <v-toolbar-title>New Day Study</v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="isAuthenticated == true">
          <span style="cursor: pointer" @click="logout">LOGOUT</span>
        </div>
      </v-app-bar>
    </nav>

    <v-main>
      <v-container fluid>
        <v-layout justify-center align-center>
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
/* eslint-disable no-debugger */
export default {
  data: () => ({
    drawer: true,
    group: null
  }),
  watch: {
    group() {
      this.drawer = true;
    },
  },
  computed: {
    items() {      
      return this.$store.getters.getUserMenuOptions;
    },
    isAuthenticated() {
      return this.$store.getters.getIsAuthenticated;
    },
    isMenuDisabled() {
       return this.$store.getters.getIsMenuDisabled;
    }
  },
  methods: {
    logout() {
      this.$store.commit("setToken", "");
      this.$router.push("login");
    },
  },

  mounted(){
     console.log(process.env.VUE_APP_BASE_URL)
  }
};
</script>